import { ArrowLeft, CreditCard, Building2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';

export const Zahlungsmethoden = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      {/* Header */}
      <div className="bg-slate-900 text-white py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link to="/" className="inline-flex items-center gap-2 text-teal-400 hover:text-teal-300 mb-6 transition-colors">
            <ArrowLeft className="w-4 h-4" />
            <span>Zurück zur Startseite</span>
          </Link>
          <h1 className="text-4xl font-bold">Zahlungsmethoden</h1>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-8 md:p-12">
          
          <p className="text-slate-600 text-lg mb-10">
            Wir bieten Ihnen folgende sichere Zahlungsmöglichkeiten:
          </p>

          <div className="grid md:grid-cols-2 gap-8">
            
            {/* PayPal */}
            <div className="bg-slate-50 rounded-2xl p-8 border border-slate-200">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-16 h-16 bg-blue-100 rounded-2xl flex items-center justify-center">
                  <svg className="w-10 h-10 text-blue-600" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M7.076 21.337H2.47a.641.641 0 0 1-.633-.74L4.944.901C5.026.382 5.474 0 5.998 0h7.46c2.57 0 4.578.543 5.69 1.81 1.01 1.15 1.304 2.42 1.012 4.287-.023.143-.047.288-.077.437-.983 5.05-4.349 6.797-8.647 6.797h-2.19c-.524 0-.968.382-1.05.9l-1.12 7.106zm14.146-14.42a3.35 3.35 0 0 0-.607-.541c-.013.076-.026.175-.041.254-.93 4.778-4.005 7.201-9.138 7.201h-2.19a.563.563 0 0 0-.556.479l-1.187 7.527h-.506l-.24 1.516a.56.56 0 0 0 .554.647h3.882c.46 0 .85-.334.922-.788.06-.26.76-4.852.816-5.09a.932.932 0 0 1 .923-.788h.58c3.76 0 6.705-1.528 7.565-5.946.36-1.847.174-3.388-.777-4.471z"/>
                  </svg>
                </div>
                <div>
                  <h2 className="text-2xl font-bold text-slate-900">PayPal</h2>
                  <p className="text-slate-500">Schnell & sicher</p>
                </div>
              </div>
              <div className="bg-white rounded-xl p-4 border border-slate-200">
                <p className="text-sm text-slate-500 mb-1">PayPal-Adresse</p>
                <p className="text-slate-900 font-medium">akw-design@gmx.de</p>
              </div>
            </div>

            {/* Bank Transfer */}
            <div className="bg-slate-50 rounded-2xl p-8 border border-slate-200">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-16 h-16 bg-teal-100 rounded-2xl flex items-center justify-center">
                  <Building2 className="w-10 h-10 text-teal-600" />
                </div>
                <div>
                  <h2 className="text-2xl font-bold text-slate-900">Überweisung</h2>
                  <p className="text-slate-500">Klassisch & zuverlässig</p>
                </div>
              </div>
              <div className="bg-white rounded-xl p-4 border border-slate-200 space-y-3">
                <div>
                  <p className="text-sm text-slate-500">Empfänger</p>
                  <p className="text-slate-900 font-medium">Adrian Wojciechowski</p>
                </div>
                <div>
                  <p className="text-sm text-slate-500">IBAN</p>
                  <p className="text-slate-900 font-mono font-medium">DE43 1001 0178 3526 3057 81</p>
                </div>
                <div>
                  <p className="text-sm text-slate-500">Bank</p>
                  <p className="text-slate-900 font-medium">Revolut Bank UAB</p>
                </div>
              </div>
            </div>

          </div>

          <div className="mt-10 p-6 bg-teal-50 border border-teal-200 rounded-xl">
            <p className="text-teal-800 text-center">
              Bei Fragen zu Zahlungen kontaktieren Sie uns gerne unter{' '}
              <a href="mailto:akw-design@gmx.de" className="font-semibold hover:underline">
                akw-design@gmx.de
              </a>
            </p>
          </div>

        </div>

        {/* Back Button */}
        <div className="mt-8 text-center">
          <Link to="/">
            <Button variant="outline" className="rounded-full px-8">
              <ArrowLeft className="w-4 h-4 mr-2" />
              Zurück zur Startseite
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};
